import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { ActivitéService } from '../scénarisation/activité.service';
import { Activité } from '../scénarisation/models/activité.model';
import { ActivitéStore } from '../scénarisation/store/activité.store';

export const activiteResolver: ResolveFn<Observable<Activité> | undefined> = (route) => {
  const activiteService = inject(ActivitéService);
  const activiteStore = inject(ActivitéStore);
  const id = route.paramMap.get('idActivite');

  if (id == null) {
    activiteStore.unselect();
    return undefined;
  }

  return activiteService.trouveParId(id).pipe(
    tap((activité) => {
      activiteStore.ajouterActivité({ activité });
      activiteStore.select({ id: activité.id });
    }),
  );
};
